import classes from "../SeedLister.module.css"
import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"

const Control = props => {
    const { t } = useTranslation()

    return (
        <div className={classes.Wrapper}>
            {props.additional}
            <p>
                <NavLink to="/profile" end>
                    {t("misc:SeedListing.TitleIntro")}
                </NavLink>
            </p>
            <div>
                <button className={classes.Button} onClick={props.calculateResults}>
                    {t("misc:Checker.ButtonDisplayResults")}
                </button>
                <button className={classes.ButtonError} onClick={props.resetSeed}>
                    {t("misc:SeedListing.DeleteSeed")}
                </button>
            </div>
        </div>
    )
}

export default Control
